import React from 'react';
import { Link } from "react-router-dom";
import BaseClass from '../common/baseClass';

import { connect } from "react-redux";
import { changeFilter, changeDatalist, changeMutex, changeValues } from "../../redux/actions";
import { filterTavoleSelector } from "../../redux/selectors";

const common = require('../common/common');
const env = require("../../config.js").default;

class FilterTavole extends BaseClass {
	constructor(props) {
		super(props)
		this.selectId = this.props.isModal ? "select_tavole_modal" : "select_tavole"
	}
	updateList() {
		const $ = window.$;
		if (this.state.renewMutex.tavole && this.state.filtersState.modello) {
			$("#select_tavole_loader").fadeIn("fast");
			$('#' + this.selectId).attr("disabled", true);
			$("#select_tavole_error").hide();
			this.props.changeValues({ renewMutex: { tavole: false }, dataList: { tavole: {} } });
			common.apiCall(env.BACKEND + "epc/get_model_draws/", "GET", { zprod: this.state.filtersState.marca, cmoto: this.state.filtersState.modello, lang:common.getLanguage() }, true)
				.then((tavoleModello) => {
					if (tavoleModello.error === false) {
						var tavoleRaggruppate = {};
						for (var i = 0; i < tavoleModello.length; i++) {
							if (Object.keys(tavoleRaggruppate).indexOf(tavoleModello[i].DTTAV) <= -1)
								tavoleRaggruppate[tavoleModello[i].DTTAV] = [];
							tavoleModello[i].visibile = true;
							tavoleRaggruppate[tavoleModello[i].DTTAV].push(tavoleModello[i]);
						}
						$("#select_tavole_loader").fadeOut("fast");
						$('#' + this.selectId).removeAttr("disabled");
						this.props.changeDatalist("tavole", tavoleRaggruppate);

						$("#select_tavole_error").fadeOut("fast");
						$("#erroreApiTavola").fadeOut("fast");
					} else {
						$("#select_tavole_error").fadeIn("fast");
						$("#erroreApiTavola").fadeIn("fast").html('<i class="fas fa-exclamation-triangle"></i> ' + common.getTrad("Nessuna tavola trovata."));
						$("#select_tavole_loader").fadeOut("fast");
					}
				});
		}
	}

	initSelect2 = () => {
		const $ = window.$;
		var dropdownParent = this.props.isModal ? $('#modalItem') : null;

		if ($('#' + this.selectId).select2())
			$('#' + this.selectId).select2('destroy');

		$('#' + this.selectId).select2({
			language: common.getLanguage(),
			dropdownParent: dropdownParent,
			placeholder: this.state.filtersState.modello ? common.getTrad("Seleziona le tavole") : common.getTrad("Per procedere, seleziona un modello"),
			width: "100%",
			value: this.state.filtersState.tavola,
			sorter: function (data) {
				/* Sort data using lowercase comparison */
				return data.sort(function (a, b) {
					a = a.text.toLowerCase();
					b = b.text.toLowerCase();
					if (a > b) {
						return 1;
					} else if (a < b) {
						return -1;
					}
					return 0;
				});
			}
		});
		if ($('#' + this.selectId).val() !== this.state.filtersState.tavola)
			$("select#" + this.selectId).val(this.state.filtersState.tavola).trigger("change");
	}

	componentWillReceiveProps(nextProps) {
		this.updateStateWithStoreProps(nextProps);
		this.updateList();
	}

	componentWillMount(props) {
		this.updateStateWithStoreProps();
		this.updateList();
	}

	componentDidMount(props) {
		const $ = window.$;

		$('#' + this.selectId).on('select2:select keyup select2:unselect', (e) => {
			e.preventDefault();
			var codiceTavola = $("#" + this.selectId).val();
			var codiceImmagine = $("#" + this.selectId).select2().find(":selected").data("cdima");
			if (this.props.isBar === true) {
				const url = "/partsfinder/draw/" + this.state.filtersState.marca + "/" + this.state.filtersState.modello + "/" + this.state.filtersState.tavola + "/";
				window.history.replaceState(null, null, url)
			}
			
			this.props.changeValues({ renewMutex: { mostraImg: false, immagineTavola: true, distinta: true, }, dataList: { immagineTavola: [], distinta: {} }, filtersState: { tavola: codiceTavola, immagine: codiceImmagine } });

		});
		this.initSelect2();
	}

	componentDidUpdate() {
		const $ = window.$;
		if ($('#' + this.selectId).val() !== this.state.filtersState.tavola)
			$("select#" + this.selectId).val(this.state.filtersState.tavola).trigger("change");
		this.updateStateWithStoreProps();
		this.initSelect2();
		if ((this.state.filtersState.cmoto || this.state.dataList.applicazioni.length > 0) && !$("select#select_tavole").val() && $('select#select_tavole option').length > 2) {
			// $("#ricerca_filtro_tavole_pulse").addClass("animate__animated animate__bounce")
		}
		if (this.state.filtersState.tavola || !this.state.filtersState.modello)
			$("#tavoleSelContainer").removeClass("select-focus");
		
		if (!$("select#select_tavole").val() && $('select#select_tavole option').length > 2 && $("select#select_model").val()) {
			$("#tavoleSelContainer").addClass("select-focus");
			$("select#select_tavole").focus();
		}
		
		if (this.state.filtersState.tavola && this.state.filtersState.modello)
		$("#btn_view").focus();
}

	render(props) {
		let divClassContainer, divClass, select;
		const $ = window.$;
		var tavole = JSON.parse(JSON.stringify(this.state.dataList.tavole));
		var gruppiVisibili = [];
		if (this.props.isBar === true) {
			divClassContainer = "row-eq-height";
			divClass = "col-12 p-0";
			select = (
				<h5 id={`label-${this.selectId}`}>{common.getTrad("Tavole:")} <figure className="svg" src={env.MENU_ICONS_PATH + (window.cc.usePersonalIcons ? window.cc.csoft : "900000") + "/menu-veicoli.svg"} title={common.getTrad("Ricerca Modello")} alt={common.getTrad("Ricerca Modello")}></figure></h5>
			);
		}
		else if (this.props.isModal === true) {
			divClassContainer = "row-margin-standard row row-eq-height";
			divClass = "col-12  content_filtro";
			select = (
				<span>{common.getTrad("Tavole:")}</span>
			);
		}
		else {
			divClassContainer = "col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 row-eq-height";
			divClass = "col-12 content_filtro";
			select = (
				<>
					<h4 id={`label-${this.selectId}`}>{common.getTrad("Ricerca Tavole")} <figure className="svg" src={env.MENU_ICONS_PATH + (window.cc.usePersonalIcons ? window.cc.csoft : "900000") + "/menu-veicoli.svg"} title={common.getTrad("Ricerca Modello")} alt={common.getTrad("Ricerca Modello")}></figure></h4>
					<hr />
				</>
			);
		}

		if (this.state.dataList.applicazioni.length > 0 && this.state.renewMutex.tavoleApp) {

			this.props.changeValues({ renewMutex: { tavoleApp: false }, dataList: { tavole: this.state.dataList.tavole } });
		}

		if (this.state.dataList.applicazioni.length > 0) {
			var count = 0;
			for (var i = 0; i < Object.keys(tavole).length; i++) {
				var gruppo = Object.keys(tavole)[i];
				if (Array.isArray(tavole[gruppo]) && tavole[gruppo].length > 0) {
					for (var j = 0; j < tavole[gruppo].length; j++) {
						var index_applicazione = common.object_value_in_array(this.state.dataList.applicazioni, "CMOTO", this.state.filtersState.modello);
						if (!this.state.dataList.applicazioni[index_applicazione] || !this.state.dataList.applicazioni[index_applicazione].CTAVO)
							continue;
						tavole[gruppo][j].visibile = tavole[gruppo][j].CTAVO === this.state.dataList.applicazioni[index_applicazione].CTAVO;
						if (gruppiVisibili.indexOf(gruppo) <= -1 && tavole[gruppo][j].visibile) {
							gruppiVisibili.push(gruppo);
							var CTAVO = tavole[gruppo][j].CTAVO;
							var immagine = (tavole[gruppo][j].CDIMA && tavole[gruppo][j].CDIMA !== '') ? tavole[gruppo][j].CDIMA : tavole[gruppo][j].CTAVO;
							count += 1;
						}
					}
				}
			}

			if (count === 1) {
				if (this.state.filtersState.modello) {
					$("select#" + this.selectId + " option[value='" + CTAVO + "']").attr("selected", "selected");
					$("select#" + this.selectId).trigger("change");
					this.props.changeValues({ filtersState: { tavola: CTAVO, immagine: immagine }, renewMutex: { mostraImg: false, immagineTavola: true } });
				}
			}
		} else
			for (var k = 0; k < Object.keys(tavole).length; k++)
				gruppiVisibili.push(Object.keys(tavole)[k]);

		return (
			<div className={divClassContainer} role="alert" id="ricerca_filtro_tavole">
				<div className={divClass} id="ricerca_filtro_tavole_pulse">
					{select}
					<div className="form-group selectSwCustom" id="tavoleSelContainer">
						<div id="select_tavole_loader" className="select_loader" style={{ display: this.state.filtersState.modello === '' ? "none" : (Object.keys(this.state.dataList.tavole).length <= 0 ? "block" : "none") }}>
							<i className="fas fa-spinner fa-spin"></i>
						</div>
						<div id="select_tavole_error" className="select_loader" style={{ display: "none" }}>
							<i className="fas fa-exclamation-triangle text-danger"></i>
						</div>
						<select name={this.selectId} className="form-control select_tavole" id={this.selectId} aria-labelledby={`label-${this.selectId}`} disabled={this.state.renewMutex.tavole || Object.keys(this.state.dataList.tavole).length <= 0 || !this.state.filtersState.modello}>
							<option></option>
							{Object.keys(tavole).map((gruppo, keyG) => {
								if (gruppiVisibili.indexOf(gruppo) > -1 && Array.isArray(tavole[gruppo]) && tavole[gruppo].length > 0)
									return (
										<optgroup key={keyG} label={gruppo}>
											{tavole[gruppo].map((tavola, keyT) => {
												if (tavola.visibile) {
													return (
														<option data-cdima={(tavola.CDIMA && tavola.CDIMA !== '') ? tavola.CDIMA : tavola.CTAVO} key={keyT} value={tavola.CTAVO}>
															{tavola.DTAVO + " " + (tavola.DNOTE !== undefined && tavola.DNOTE !== null ? tavola.DNOTE : '')}
														</option>
													)
												}
											})}
										</optgroup>
									)
								else
									return false
							})}
						</select>
					</div>
					{this.state.filtersState.tavola !== undefined && this.state.filtersState.tavola !== null && this.state.filtersState.tavola !== "" && !this.props.isBar ?
						<Link onClick={() => $("#closeModal").click() } className=" float-right btn bottone_default" id="btn_view" to={"/draw/" + this.state.filtersState.marca + "/" + this.state.filtersState.modello + "/" + this.state.filtersState.tavola + "/"}>{common.getTrad("Visualizza Tavola")} <i className="fas fa-chevron-right"></i></Link>
						:
						""
					}
					<div style={{ display: 'none' }} id="erroreApiTavola" className="alert alert-danger" role="alert"></div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	const store = filterTavoleSelector(state);
	return { store };
}
export default connect(mapStateToProps, { changeFilter, changeDatalist, changeMutex, changeValues })(FilterTavole);
//export default FilterTavole;
